import { Link } from 'react-router-dom';
import BrandMark from '../ui/BrandMark';
import { BRAND_SIZE } from '../../constants/brand';
import { PUBLIC_FOOTER } from '../../constants/publicFooter';
import { SITE_BRAND } from '../../constants/site';
import styles from './Footer.module.css';

const APPEARANCE_TONE = { page: 'light', station: 'dark', embedded: 'dark' };

function FooterLink({ link }) {
  return link.external ? (
    <a className={styles.link} href={link.to}>{link.label}</a>
  ) : (
    <Link className={styles.link} to={link.to}>{link.label}</Link>
  );
}

export default function Footer({ content = PUBLIC_FOOTER, appearance = 'page' }) {
  return (
    <footer className={styles.footer} data-appearance={appearance}
      data-theme={appearance === 'station' ? 'night-mode' : undefined}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <Link to={content.home} className={styles.link} aria-label={content.label}>
              <BrandMark app={content.app} tone={APPEARANCE_TONE[appearance]} size={BRAND_SIZE.SM} />
            </Link>
            {content.description ? <p>{content.description}</p> : null}
          </div>
          <nav className={styles.links} aria-label={content.navigationLabel}>
            {content.links.map((link) => <FooterLink key={link.to} link={link} />)}
          </nav>
        </div>
        <div className={styles.bottom}>
          <nav className={styles.links} aria-label={content.legalLabel}>
            {content.legalLinks.map((link) => <FooterLink key={link.to} link={link} />)}
          </nav>
          <span suppressHydrationWarning>&copy; {new Date().getFullYear()} {SITE_BRAND}</span>
        </div>
        {content.note ? <p className={styles.note}>{content.note}</p> : null}
      </div>
    </footer>
  );
}
